import React, { useEffect } from 'react'
import Routers from './routes'
import { BrowserRouter } from 'react-router-dom'
import GlobalStyle from 'theme/GlobalStyle'
import { initClarity , identifyUser } from './utils/clarity'
import { initPostHog, identifyPostHogUser } from './utils/posthog'
const { REACT_APP_POSTHOG_API_KEY } = process.env;
const { REACT_APP_POSTHOG_HOST } = process.env;
const { ENVIRONMENT } = process.env;
// const { REACT_APP_CLARITY_PROJECT_ID } = process.env


const App = ({ token, permissions, userData }) => {
  useEffect(() => {
  //   if (process.env.REACT_APP_CLARITY_PROJECT_ID != 'null') {
  //     initClarity(process.env.REACT_APP_CLARITY_PROJECT_ID)
  //   }
  initPostHog(REACT_APP_POSTHOG_API_KEY, REACT_APP_POSTHOG_HOST);
 }, [])

  useEffect(() => {
    const email = userData?.email
    if (email) {
      identifyUser(email)
      identifyPostHogUser(email, {
        // Environment
        environment: ENVIRONMENT,
      })
    }
  }, [userData])
  
  return (
    <BrowserRouter>
      <GlobalStyle />
      <Routers token={token}  permissions={permissions} />
    </BrowserRouter>
  )
}

export default App
